export default __webpack_public_path__ + "static/media/vire17.c6ae0290.jpg";